import React from "react";

import { OrderAirlinesDataProvider } from "../../common/data-providers/OrderAirlinesDataProvider";
import { OnPremOrderListingProvider } from "./context/OnPremOrderListingProvider";
import { OnPremOrderListing } from "./OnPremOrderListing";

export const OnPremOrderListingDashboard: React.VFC = () => {
    return (
        <OnPremOrderListingProvider>
            <OrderAirlinesDataProvider>
                <OnPremOrderListing />
            </OrderAirlinesDataProvider>
        </OnPremOrderListingProvider>
    );
};
